<div class="availability-col">
  <div class="btn-toolbar">
    <div class="btn-group add-to-cart-wrapper">
      <app-add-to-cart [productCode]="productCode" [outer]="outer" [unpackedQuantity]="unpackedQuantity" [theme]="theme"
        [availability]="availability" [updating]="updating" [isDateCourte]="product?.isDateCourte"></app-add-to-cart>
    </div>
    <div id="stock-indicator" *ngIf="showStockIndicator" class="availability-wrapper btn-group">
      <app-stock-indicator [productCode]="productCode" [availability]="availability" [product]="product"
        [updating]="updating"></app-stock-indicator>
    </div>
  </div>
</div>